import { useEffect, useState } from 'react';
import { api } from '../api';
import '../pages.css';

// One video card. Streams through the Cloudflare gateway (R2), so it works
// from mainland China without touching Google.
function VideoCard({ v }) {
  const [status, setStatus] = useState('loading');

  return (
    <div className="video-card">
      <video
        controls
        src={api.mediaUrl(v.r2Key)}
        preload="metadata"
        onLoadedMetadata={() => setStatus('ready')}
        onError={() => setStatus('error')}
      >
        <track kind="captions" />
      </video>
      {status === 'error' && <div className="video-placeholder">无法加载视频</div>}
      <div className="video-title">{v.title}</div>
      {v.description && <div className="video-desc">{v.description}</div>}
    </div>
  );
}

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    api.videos()
      .then((data) => { if (!cancelled) setVideos(data.videos || []); })
      .catch((err) => { if (!cancelled) setError(err.message || '加载失败'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const term = q.trim().toLowerCase();
  const filtered = term
    ? videos.filter((v) => (v.title || '').toLowerCase().includes(term))
    : videos;

  return (
    <div className="page">
      <h1>视频 Videos</h1>
      <input
        className="search-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="按标题搜索视频…"
      />
      {loading ? (
        <p>加载中…</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : filtered.length === 0 ? (
        <p>没有找到视频。</p>
      ) : (
        <div className="video-grid">
          {filtered.map((v) => <VideoCard key={v.id} v={v} />)}
        </div>
      )}
    </div>
  );
}
